import { useEffect } from "react"

import { useAuth0 } from "@auth0/auth0-react"
import { useRouter } from "expo-router"

import { Box, Spinner, Text, VStack } from "wealthmode-frontend/gluestack/ui"

export default function Logout() {
  const { logout } = useAuth0()
  const router = useRouter()

  useEffect(() => {
    logout().then(() => {
      router.replace("/")
    })
  }, [logout, router])

  return (
    <div className="bg-background-primary min-h-screen flex items-center justify-center">
      <Box className="w-full max-w-md mx-auto px-4">
        <VStack className="items-center gap-4">
          <Spinner size="large" />
          <Text className="text-foreground-tertiary">Logging out...</Text>
        </VStack>
      </Box>
    </div>
  )
}
